
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";

@Component({})
export default class DoKoCardBackPattern extends Vue {
  card_id = uuidv4() as string;
  over = false;

  @Prop({
    type: Boolean,
    default: false,
  })
  private hoverable!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  private back!: boolean;

  // ('♣', 'black'), ('♠', 'black'), ('♥', '#d6002b'), ('♦', '#d6002b')
  // ('A', 'A'), ('10', '10'), ('9', '9'), ('K','K'), ('D','Q'), ('B','J')
  @Prop({
    type: String,
    default: "Q",
  })
  private value!: string;

  @Prop({
    type: String,
    default: "♣",
  })
  private color!: string;
  // 110x182
  // 735x1215
  @Prop({
    type: Number,
    default: 110 / 735,
  })
  private scale!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get width() {
    return this.scale * 735;
  }
  get height() {
    return this.scale * 1215;
  }

  get coloring() {
    return ["♥", "♦"].includes(this.color) ? "#d6002b" : "#000";
  }

  get backgroundColor() {
    return this.back ? "#ff6c6c" : "#fff";
  }

  get fontStyle() {
    return {
      fontSize: "43.15018082px",
      textAlign: "center",
      textAnchor: "middle",
      strokeWidth: "0.22474051px",
      fill: this.coloring,
    };
  }

  @Watch("over", {
    immediate: true,
  })
  onHover(val: boolean, oldVal: boolean) {
    console.log("onCardHover", val, oldVal, this.calcY, this.hoverable);
  }

  get calcY() {
    return this.hoverable && this.over ? this.y - 20 : this.y;
  }
  get transformText() {
    return `translate(${this.x} ${this.calcY}) scale(${this.scale})`;
  }

  created() {
    console.log("DoKoCard", this.color, this.value, this.transformText);
  }
}
